import { useMemo, useState } from "react";

import { useCard } from "../../../../../../reactQuery/cards";
import { useBoardUsers } from "../../../../../../reactQuery/users";
import { currentUserId, isAdmin } from "../../../../../../utils/constants";
import { useCustomSearchParams } from "../../../../../../hooks/useCustomSearchParams";
import { useResponsive } from "../../../../../../hooks/useResponsive";
import { useSidebarMutations } from "./useSidebarMutations";
import { getResponseData } from "../../../../../../reactQuery/response";
import {
  getAssigneeOptions,
  getCollaboratorOptions,
  getCollaboratorUserIds,
} from "./sidebarUsersUtils";

export function useDetailSidebarState({ cardId, boardPermission }) {
  const [addWorklog, setAddWorklog] = useState(false);
  const [milestone] = useCustomSearchParams("milestone");
  const isMobile = useResponsive("down", "md");
  const { card } = useCard(cardId);
  const data = useMemo(() => getResponseData(card, {}), [card]);
  const boardId = data?.board?.board_id || data?.board_id;
  const { data: boardUsersQuery } = useBoardUsers(boardId);
  const boardUsers = useMemo(
    () => getResponseData(boardUsersQuery, []),
    [boardUsersQuery]
  );

  const checkBoardOwnerOrAdmin = useMemo(
    () =>
      isAdmin() ||
      data?.board?.owner_user_id === currentUserId() ||
      boardPermission?.is_admin,
    [boardPermission?.is_admin, data?.board?.owner_user_id]
  );

  const conditionCheck = useMemo(
    () =>
      checkBoardOwnerOrAdmin ||
      data?.assigned_to_user_id === currentUserId() ||
      data?.reporter === currentUserId(),
    [checkBoardOwnerOrAdmin, data?.assigned_to_user_id, data?.reporter]
  );

  const collaboratorUserIds = useMemo(
    () => getCollaboratorUserIds(data?.collaborators),
    [data?.collaborators]
  );

  const assigneeOptions = useMemo(
    () =>
      getAssigneeOptions(
        boardUsers,
        collaboratorUserIds,
        data?.assigned_to_user_id
      ),
    [boardUsers, collaboratorUserIds, data?.assigned_to_user_id]
  );

  const collaboratorOptions = useMemo(
    () =>
      getCollaboratorOptions(
        boardUsers,
        collaboratorUserIds,
        data?.assigned_to_user_id
      ),
    [boardUsers, collaboratorUserIds, data?.assigned_to_user_id]
  );

  const sidebarMutations = useSidebarMutations(cardId, data?.board_id, milestone);

  return {
    addWorklog,
    assigneeOptions,
    conditionCheck,
    collaboratorOptions,
    data,
    isMobile,
    setAddWorklog,
    sidebarMutations,
    checkBoardOwnerOrAdmin,
  };
}
